<template>
  <div class="item--box-style">
    <div class="ut-flex ut-fc">
      <div class="ut-flex ut-fc" style="margin-top: -16px">
        <div style="background: white" class="dt-icon-container">
          <img style="cursor: pointer" :src="iconPath" class="v5 s1" />
        </div>
        <p>{{ headerTitle }}</p>
      </div>
      <div>
        <button
          v-for="(item, index) in buttonList"
          :key="item.text + index"
          class="dt-button"
          style="width: 216px"
          @click="onButtonClick(item)"
        >
          {{ item["text"] }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    headerTitle: {
      type: String,
      default: "",
    },
    iconPath: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onButtonClick: function (item) {
      this.$emit("onButtonClick", item.value);
    },
  },
};
</script>

<style lang="scss">

</style>
